// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".body-item[data-v-ab37edc6]{display:flex;align-items:center;margin:12px 0;cursor:pointer}.body-item .item-icon[data-v-ab37edc6]{display:flex;justify-content:center;font-size:24px;width:32px;margin-right:8px}.body-item .item-text[data-v-ab37edc6]{width:100%}.body-item .item-text h6[data-v-ab37edc6]{width:100%;font-size:14px;line-height:18px;margin:0}.body-item.disabled[data-v-ab37edc6]{opacity:.6}", ""]);
// Exports
module.exports = exports;
